import { createRouter, createWebHashHistory } from 'vue-router';
import menuList from './menuList';
import { sysStore } from '@/stores/sysStore.js';

const routes = [
  {
    path: '/',
    redirect: '/bigScreen',// 重定向到首页
    name: '首页',
    component: () => import('@/views/Home.vue'),
    children: menuList
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'noPage',
    component: () => import('@/views/Home.vue'),
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((
  to, from, next
) => {
  let store = sysStore();
  store.setCurrentMenu(to);//存入当前菜单项
  next()
})

export default router
